import React from 'react'
import { useTranslation } from "react-i18next";
import PropTypes from 'prop-types';

function CValidator(props) {
    const { t } = useTranslation();

    //Parametros de entrada.
    const { 
        isInValid = false,
        isInValidText = null,
        inValidText = null,
    } = props;

    return (
        <>
            {
                isInValid === true &&
                <div className="invalid-textbox">
                    { isInValidText !== null ? isInValidText : inValidText === null ? t('data-lang-msg-required') : t(inValidText) }
                </div>
            }
        </>
    );
}

CValidator.propTypes = {
    isInValid: PropTypes.bool.isRequired,
    isInValidText: PropTypes.string,
    inValidText: PropTypes.string,
};

export default CValidator;

